import httpService from '../service/httpService.js'
import store from '../store/index.js'
import User from '../api/auth'
import config from '../config/index'
/*
    判断前往的路径是否为分享路径
*/
const isShare = path => {
  let regs = config.sharePath.map(item => new RegExp('^' + item))
  return regs.some(item => item.test(path))
}
/*
    判断前往路径是否为需引导注册的路径,并返回类型
*/
const shouldGuid = path => {
  let type = null
  let paths = config.registerGuidPath
  for (let i = 0; i < paths.length; i++) {
    let reg = new RegExp('^' + paths[i])
    if (reg.test(path)) {
      type = path.split('/')[1]
      break
    }
  }
  return type
}

/*判断是否为ios设备
 *@method isIos
 *@param  无
 *@return {Boolean} true  为ios false 安卓
 */
const isIos = () => {
  let u = navigator.userAgent
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
};
/*获取url指定名称的参数
 *@method getParamsFromUrl
 *@param {Srting} paramName 想获取的参数的名称
 *@return {String} 指定名称参数结果
 */
const getParamsFromUrl = paramName => {
  var args = new Object()
  var argsStr = location.href.substring(location.href.lastIndexOf('?')) //获取URL参数字符串
  if (argsStr.length > 0) {
    argsStr = argsStr.substring(1)
    var nameValueArr = argsStr.split('&') //多参数
    for (var i = 0; i < nameValueArr.length; i++) {
      var pos = nameValueArr[i].indexOf('=')
      if (pos == -1) continue //如果没有找到就跳过
      var argName = nameValueArr[i].substring(0, pos) //提取name
      var argVal = nameValueArr[i].substring(pos + 1) //提取value
      args[argName] = unescape(argVal)
    }
    return args[paramName]
  }
}
/*获取系统信息以及个人信息
 *@method getSystemInfo
 *@param
 *@return
 */
const getSystemInfo = () => {
  let token = getParamsFromUrl('token')
  let platform = getParamsFromUrl('platform')
  store.commit('system/setPlatform', platform || config.platform)
  if (store.state.system.platform !== 'wechat') {
    if (token) User.getProfile()
  }
}
/*判断是否在微信
 *@method isWeixin
 *@param
 *@return
 */
const isWeixin = () => {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}
/*
    @name   delHTML
    @desc   删除html标签
    @params
            str         传入的文本字符串
    @return
            str         不含html标签的文本
*/

const delHTML = str => {
  return str.replace(/<[^>]+>/g, '')
}
export {
  isIos,
  isShare,
  delHTML,
  shouldGuid,
  getSystemInfo,
  getParamsFromUrl,
  isWeixin
}



// WEBPACK FOOTER //
// ./src/utils/index.js